import React from "react";
import { Box, Typography, Link as MuiLink, useMediaQuery } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import map from "../assets/map.png";
import mapTab from "../assets/mapTablet.png";
import mapMob from "../assets/mapMobile.png";

const footerNavItems = [
  { label: "About", path: "/about" /*about*/ },
  { label: "Differentiation", path: "/differentiation" /*"/differentiation"*/ },
  {
    label: "Immersive Experience",
    path: "/immersive-experience",
  },
  { label: "Services", path: "/services" },
  { label: "Product Agnostic", path: "/product-agnostic" },
  { label: "Case Studies", path: "/case-study-dam-repository" },
  {
    label: "Discovery Framework",
    path: "/discovery-framework" ,
  },
  { label: "Our Practice", path: "/our-practice" },
  { label: "DAM Journey", path: "/dam-journey" },
  {
    label: "DAM Training",
    path: "/dam-trainiong-corporate",
  },
];

const Footer = () => {
  const isDesktop = useMediaQuery("(min-width:1220px)");
  const isTablet = useMediaQuery("(max-width:1360px)");
  const isMobile = useMediaQuery("(max-width:743px)");
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#2A2177",
        color: "#FFFFFF",
      //  maxWidth: "1440px",
      }}
    >
      {/* Main Footer Content */}
      <Box
        sx={{
          px: isDesktop ? "84px" : "16px",
          py: "30px",
          display: "flex",
          flexDirection: "column",
          gap: { xs: 4, md: 4 },
        }}
      >
        {/* Top Row: Company Info + Nav Links */}
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: { xs: 4, md: 6 },
          }}
        >
          {/* Company Info */}
          <Box sx={{ flex: 1 }}>
            <Typography
              sx={{
                fontSize: "1.5rem",
                fontWeight: 700,
                mb: 2,
                color: "#FFFFFF",
              }}
            >
              DAM Journey LLC
            </Typography>
            <Typography
              sx={{
                fontSize: "1rem",
                fontWeight: 400,
                color: "#FFFFFF",
                lineHeight: 1.7,
                maxWidth: "340px",
              }}
            >
              Helping organizations plan, implement, and operate Digital Asset
              Management solutions to unlock the full value of their digital
              assets.
            </Typography>
          </Box>

          {/* Navigation Links */}
          <Box
            sx={{
              minWidth: isDesktop ? "160px" : "220px",
              display: "flex",
              flex:isTablet ? 1 :"",
              flexDirection: "column",
              gap: 1.5,
            }}
          >
            {footerNavItems.map((item) => (
              <MuiLink
                key={item.label}
                component={RouterLink}
                to={item.path}
                underline="none"
                sx={{
                  fontSize: "1rem",
                  fontWeight: 400,

                  color: "#FFFFFF",
                  "&:hover": {
                    color: "rgba(255, 255, 255, 0.75)",
                  },
                }}
              >
                {item.label}
              </MuiLink>
            ))}
          </Box>

          {/* Contact Section - only in desktop row */}
          {isDesktop && (
            <Box
              sx={{
                flex: 1.5,
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                gap: { xs: 3, sm: 4 },
              }}
            >
              {/* Contact Title + Map */}
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    fontSize: "1.5rem",
                    fontWeight: 700,
                    mb: 2,
                    color: "#FFFFFF",
                  }}
                >
                  Contact
                </Typography>
                <Box sx={{ width: "100%", overflow: "hidden" }}>
                  <Box
                    component="img"
                    src={map}
                    alt="DAM Journey Map"
                    sx={{
                      height: "256px",
                      width: "320px",
                    }}
                  />
                </Box>
              </Box>

              {/* Contact Details */}
              <Box
                sx={{
                  minWidth: "240px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 4,
                  justifyContent: "center",
                  pt: 5,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <EmailOutlinedIcon
                    sx={{ fontSize: 24, color: "rgba(255,255,255,0.75)" }}
                  />
                  <MuiLink
                    href="mailto:inquiry@damjourney.com"
                    underline="none"
                    sx={{
                      fontSize: "1rem",
                      color: "#FFFFFF",
                      "&:hover": { color: "rgba(255, 255, 255, 0.75)" },
                    }}
                  >
                    inquiry@damjourney.com
                  </MuiLink>
                </Box>
                <Box
                  sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}
                >
                  <LocationOnOutlinedIcon
                    sx={{
                      fontSize: 24,
                      color: "#FFFFFF",
                      mt: 0.2,
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      color: "#FFFFFF",
                      lineHeight: 1.6,
                    }}
                  >
                    12842 Jackson Circle
                    <br />
                    Thornton, CO 80241 – USA
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <PhoneOutlinedIcon
                    sx={{ fontSize: 24, color: "rgba(255,255,255,0.75)" }}
                  />
                  <MuiLink
                    href="tel:6504402946"
                    underline="none"
                    sx={{
                      fontSize: "1rem",
                      color: "#FFFFFF",
                      "&:hover": { color: "rgba(255, 255, 255, 0.75)" },
                    }}
                  >
                    650-440-2946
                  </MuiLink>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <SupportAgentOutlinedIcon
                    sx={{ fontSize: 24, color: "rgba(255,255,255,0.75)" }}
                  />
                  <MuiLink
                    href="mailto:support@damjourney.com"
                    underline="none"
                    sx={{
                      fontSize: "1rem",
                      color: "#FFFFFF",
                      "&:hover": { color: "rgba(255, 255, 255, 0.75)" },
                    }}
                  >
                    support@damjourney.com
                  </MuiLink>
                </Box>
              </Box>
            </Box>
          )}
        </Box>

        {/* Contact Section - tablet/mobile: full width below */}
        {!isDesktop && (
          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: { xs: 3, sm: 4 },
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontSize: "1.5rem",
                  fontWeight: 700,
                  mb: 2,
                  color: "#ffffff",
                }}
              >
                Contact
              </Typography>
              <Box sx={{ width: "100%", overflow: "hidden" }}>
                <Box
                  component="img"
                  src={isMobile ? mapMob : mapTab}
                  alt="DAM Journey Map"
                  sx={{
                    height: isMobile ? "174px !important" : "229px",
                    width: isMobile ? "320px" : "356px",
                  }}
                />
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2.5,
                justifyContent: "center",
                flex:isTablet ? 1 :"",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <EmailOutlinedIcon
                  sx={{ fontSize: 24, color: "rgba(255,255,255,0.75)" }}
                />
                <MuiLink
                  href="mailto:inquiry@damjourney.com"
                  underline="none"
                  sx={{
                    fontSize: "1rem",
                    color: "#FFFFFF",
                    "&:hover": { color: "rgba(255, 255, 255, 0.75)" },
                  }}
                >
                  inquiry@damjourney.com
                </MuiLink>
              </Box>
              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
                <LocationOnOutlinedIcon
                  sx={{
                    fontSize: 24,
                    color: "rgba(255,255,255,0.75)",
                    mt: 0.2,
                  }}
                />
                <Typography
                  sx={{
                    fontSize: "1rem",
                    color: "#FFFFFF",
                    lineHeight: 1.6,
                  }}
                >
                  12842 Jackson Circle
                  <br />
                  Thornton, CO 80241 – USA
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <PhoneOutlinedIcon
                  sx={{ fontSize: 24, color: "rgba(255,255,255,0.75)" }}
                />
                <MuiLink
                  href="tel:6504402946"
                  underline="none"
                  sx={{
                    fontSize: "1rem",
                    color: "#FFFFFF",
                    "&:hover": { color: "rgba(255, 255, 255, 0.75)" },
                  }}
                >
                  650-440-2946
                </MuiLink>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <SupportAgentOutlinedIcon
                  sx={{ fontSize: 24, color: "rgba(255,255,255,0.75)" }}
                />
                <MuiLink
                  href="mailto:support@damjourney.com"
                  underline="none"
                  sx={{
                    fontSize: "1rem",
                    color: "#FFFFFF",
                    "&:hover": { color: "rgba(255, 255, 255, 0.75)" },
                  }}
                >
                  support@damjourney.com
                </MuiLink>
              </Box>
            </Box>
          </Box>
        )}
      </Box>

      {/* Registered Trademark Notice */}
      <Box
        sx={{
          px: isDesktop ? "84px" : "16px",
          pb: 1,
          pt: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: "0.75rem",
            color: "#FFFFFF",
          }}
        >
          ® Immersive Experience is a registered trademark of{" "}
          <MuiLink
            href="https://asvpm.org"
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            sx={{
              color: "#FFFFFF",
              "&:hover": { color: "rgba(255, 255, 255, 0.75)" },
            }}
          >
            ASVPM.org
          </MuiLink>
        </Typography>
      </Box>

      {/* Bottom Bar - Copyright */}
      <Box
        sx={{
          borderTop: "1px solid rgba(255, 255, 255, 0.15)",
        //  maxWidth: "1440px",
          px: isDesktop ? "84px" : "16px",
          py: 2.5,
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: { xs: 1.5, sm: 0 },
        }}
      >
        <Typography
          sx={{
            fontSize: "0.87rem",
            color: "#FFFFFF",
          }}
        >
          © 2026 DAM Journey LLC. All rights reserved.
        </Typography>

        <Box
          sx={{
            display: "flex",
            gap: { xs: 2, sm: 3 },
            flexWrap: "wrap",
          }}
        >
          <MuiLink
            component={RouterLink}
            to="/privacy-policy"
            underline="none"
            sx={{
              fontSize: "0.87rem",
              color: "#FFFFFF",
              "&:hover": { color: "rgba(255, 255, 255, 0.75)" },
            }}
          >
            Privacy Policy
          </MuiLink>
          <MuiLink
            component={RouterLink}
            to="/terms-of-use"
            underline="none"
            sx={{
              fontSize: "13px",
              color: "#FFFFFF",
              "&:hover": { color: "rgba(255, 255, 255, 0.75)" },
            }}
          >
            Terms of Service
          </MuiLink>
          <MuiLink
            component={RouterLink}
            to="/cookie-policy"
            underline="none"
            sx={{
              fontSize: "0.87rem",
              color: "#FFFFFF",
              "&:hover": { color: "rgba(255, 255, 255, 0.75)" },
            }}
          >
            Cookie Policy
          </MuiLink>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
